<template>
  <!-- 社保夯实率预警：单月不达标=黄 / 连续 3 月不达标=橙 / 年度不达标=红 -->
  <riskWarn domain="social" pageTitle="社保夯实率预警" themeColor="#00C48C"
    :subTabs="['社保夯实率']" :showAmount="true" />
</template>

<script>
import riskWarn from './riskWarn'
export default {
  name: 'socialRate',
  components: { riskWarn }
}
</script>
